import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/categories";

const aboutLinks = [
  { to: "/about", label: "关于我们" },
  { to: "/about#principle", label: "信源原则" },
  { to: "/about#voices", label: "读者口碑" },
  { to: "/about#contact", label: "投稿与联系" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-100 text-foreground-800">
      <div className="container-page grid grid-cols-1 gap-10 py-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
              <i className="ri-fire-fill"></i>
            </span>
            <div>
              <p className="font-heading text-lg font-extrabold text-foreground-950">
                明星八卦圈内
              </p>
              <p className="text-[11px] text-foreground-500">Staff · Agent · Insider</p>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            汇集剧组工作人员、经纪人、业内制片与知情者的一手消息。以匿名、可信、有细节的视角，每天为你递上一份新鲜的圈内热瓜。
          </p>
          <div className="mt-4 flex items-center gap-2 text-sm">
            <a
              href="mailto:hello@mingxingbaguajuan.example"
              className="inline-flex items-center gap-1.5 text-foreground-700 transition-colors hover:text-primary-600"
            >
              <i className="ri-mail-line"></i>
              hello@mingxingbaguajuan.example
            </a>
          </div>
        </div>

        <div>
          <h4 className="label-caps text-foreground-600">圈内栏目</h4>
          <ul className="mt-4 space-y-2.5">
            {CATEGORIES.map((c) => (
              <li key={c.key}>
                <Link
                  to={`/category/${c.key}`}
                  className="inline-flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600"
                >
                  <i className={`${c.icon} text-primary-500`}></i>
                  {c.name}
                  <span className="text-xs text-foreground-400">· {c.source}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="label-caps text-foreground-600">站点导航</h4>
          <ul className="mt-4 space-y-2.5">
            {aboutLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="inline-flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600"
                >
                  <i className="ri-arrow-right-s-line text-secondary-500"></i>
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-primary-600"
              >
                <i className="ri-arrow-right-s-line text-secondary-500"></i>
                返回首页
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="label-caps text-foreground-600">今日推荐</h4>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link
                to="/article/hongtan-de-shi-miao-zhong"
                className="text-sm leading-snug text-foreground-700 transition-colors hover:text-primary-600"
              >
                红毯那十秒钟：站姿是提前两周就排好的
              </Link>
            </li>
            <li>
              <Link
                to="/article/yingshou-zhuo-shang-de-na-ju-zhenhua"
                className="text-sm leading-snug text-foreground-700 transition-colors hover:text-primary-600"
              >
                应酬桌上那句真话，散场后没人认账
              </Link>
            </li>
            <li>
              <Link
                to="/article/shijing-shi-jixingren-jile"
                className="text-sm leading-snug text-foreground-700 transition-colors hover:text-primary-600"
              >
                试镜室里，经纪人在纸上到底记了什么
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="container-page flex flex-col items-center justify-between gap-3 py-5 text-xs text-foreground-500 sm:flex-row">
          <p>
            © 2026 明星八卦圈内 · 本网站内容均为虚构行业观察与匿名信源叙述，仅供娱乐，请勿对号入座。
          </p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-secondary-500"></i>
            匿名信源保护 · 拒绝恶意造谣中伤
          </p>
        </div>
      </div>
    </footer>
  );
}